import { render } from "./PaydayAccrualConfiguration.vue?vue&type=template&id=0bfa8484&scoped=true"
import script from "./PaydayAccrualConfiguration.vue?vue&type=script&lang=js"
export * from "./PaydayAccrualConfiguration.vue?vue&type=script&lang=js"

import "./PaydayAccrualConfiguration.vue?vue&type=style&index=0&id=0bfa8484&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfa8484"]])

export default __exports__